export const tokenAddresses = {
  EUL: "0x462cD9E0247b2e63831c3189aE738E5E9a5a4b64",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0xFA31599a4928c2d57C0dd77DFCA5DA1E94E6D2D2",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
